import { createContext, type ReactNode, useContext, useState } from 'react';

const DrawerNavigationContext = createContext<{
  isOpen: boolean;
  setIsOpen: (v: boolean) => void;
} | null>(null);

export const DrawerNavigationProvider: React.FC<{ children: ReactNode }> = ({
  children,
}) => {
  const [isOpen, setIsOpen] = useState(false);
  return (
    <DrawerNavigationContext.Provider value={{ isOpen, setIsOpen }}>
      {children}
    </DrawerNavigationContext.Provider>
  );
};

// eslint-disable-next-line react-refresh/only-export-components
export const useDrawerNavigation = () => {
  const ctx = useContext(DrawerNavigationContext);
  if (!ctx) throw new Error('useDrawerNavigation must be used inside provider');
  return ctx;
};
